/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Attach_Id_PlaceholderInputs */

const cs_chat_attach_id_placeholder = /** @type {(inputs: Chat_Attach_Id_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID entity (UUID nebo global ID)`)
};

const en_chat_attach_id_placeholder = /** @type {(inputs: Chat_Attach_Id_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entity ID (UUID or global ID)`)
};

/**
* | output |
* | --- |
* | "Entity ID (UUID or global ID)" |
*
* @param {Chat_Attach_Id_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_attach_id_placeholder = /** @type {((inputs?: Chat_Attach_Id_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Attach_Id_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_attach_id_placeholder(inputs)
	return cs_chat_attach_id_placeholder(inputs)
});